export default "__VITE_ASSET__DPt7MP86__"